module.exports = __webpack_public_path__ + "img/52.25fadaf5.jpg";